import { graphql } from '~/lib/graphql'

export const SubscribeInventoryNotification = graphql(`
  mutation subscribeInventoryNotification($restaurantId: RestaurantId!) {
    subscribeInventoryNotification(restaurantId: $restaurantId)
  }
`)

export const UnsubscribeInventoryNotification = graphql(`
  mutation unsubscribeInventoryNotification($restaurantId: RestaurantId!) {
    unsubscribeInventoryNotification(restaurantId: $restaurantId)
  }
`)
